'use strict';

import 'jquery';

const RR_PARAMS = ['RR_WCID', 'RR_WCID_TTL', 'REFERRALCODE'];

export default {

  /**
   * Injects querystring params from ReferralRock affiliate links with necessary tracking params
   * Attempts to use MutationObserver if the browser supports it, otherwise falls back to a sleep
   */
  injectReferralRockTrackingQuerystring() {

    $(`a[href*="app.markup.io"]`).each((i, el) => {

      // Get params from current window and destination url
      let currentWindowUrl = new URL(window.location.href);
      let destinationUrl   = new URL(el.href);

      // Inject params
      for ( const key of RR_PARAMS ) {
        let value = currentWindowUrl.searchParams.get(key);
        if ( value && !destinationUrl.searchParams.get(key) ) {
          destinationUrl.searchParams.append(key, value);
        }
      }

      // Update href
      $(el).attr('href', destinationUrl.href);
    });

  },

}
